import React from 'react';
import { NavItem } from '../NavItem/NavItem';
import { menuItems } from '@/constants';

export const Nav = () => {
  return (
    <nav className="flex min-w-0 max-w-full flex-nowrap items-center justify-center gap-0">
      {menuItems.map((item, idx) => (
        <NavItem items={item} key={idx} />
      ))}
    </nav>
  );
};
